<section fxLayout="column" fxFlex fxLayoutGap="40px">
  <article *ngIf="isCreelPreview()" fxLayout="column" fxLayoutGap="20px">
    <article fxLayout="row" *ngIf="canShowPreviewForColorSet()">
      <div fxFlex="150px">
        <vdw-ellipsis-label appDataCy="colors-creel-preview" class="creel-preview-label" [text]="'TEXTILE_DATA.COLOR.COLOR' | bmsTranslate: {count: 2}" matTooltipPosition="above"></vdw-ellipsis-label>
      </div>
      <div fxFlex fxLayout="row wrap" fxLayoutGap="16px">
        <div *ngFor="let color of getUniqueColors(); let colorIndex = index" fxLayout="row" fxLayoutGap="8px" class="item-definition">
          <div class="item-preview" [style.border-color]="color.hexadecimalColorCode" [style.box-shadow]="'0 3px 6px -2px' + color.hexadecimalColorCode">
            <span class="antialiased">{{ colorIndex + 1 }}</span>
          </div>
          <span class="item-definition-name">{{ color.name }}</span>
        </div>
      </div>
    </article>

    <article fxLayout="row" *ngIf="canShowPreviewForYarnSet()">
      <div fxFlex="150px">
        <vdw-ellipsis-label
          appDataCy="yarns-creel-preview"
          class="creel-preview-label"
          [text]="'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2}"
          matTooltipPosition="above"
        ></vdw-ellipsis-label>
      </div>
      <div fxFlex fxLayout="row wrap" fxLayoutGap="16px">
        <div *ngFor="let yarnType of getUniqueYarnTypes(); let yarnTypeIndex = index" fxLayout="row" fxLayoutGap="8px" class="item-definition">
          <div class="item-preview yarn-type-preview">
            <span class="antialiased">{{ yarnTypeIndex + 1 }}</span>
          </div>
          <span class="item-definition-name">{{ yarnType.name }}</span>
        </div>
      </div>
    </article>
  </article>

  <article fxLayout="row">
    <form [formGroup]="showCreelPreviewForm">
      <div *ngIf="isCreelPreview()" fxFlex="150px" fxLayout="column" fxLayoutGap="24px">
        <vdw-ellipsis-label fxFlex="19px" *ngIf="canShowPreviewForColorSet()" class="creel-preview-label" [text]="nameOfYarnSet" matTooltipPosition="above"></vdw-ellipsis-label>
        <vdw-ellipsis-label fxFlex="19px" *ngIf="canShowPreviewForYarnSet()" class="creel-preview-label" [text]="nameOfColorSet" matTooltipPosition="above"></vdw-ellipsis-label>
        <div fxLayout="row" class="number-of-dents-container">
          <vdw-ellipsis-label
            appDataCy="dents-creel-preview"
            fxLayout="start center"
            class="creel-preview-label number-of-dents-label"
            [text]="'TEXTILE_DATA.CREEL.DENT' | bmsTranslate"
            matTooltipPosition="above"
          ></vdw-ellipsis-label>
          <mat-form-field class="number-of-dents">
            <input matInput vdwL10nDecimal type="number" (keyup)="setScrollPosition()" [min]="minimumAmountOfDents" [max]="maximumAmountOfDents" step="1" formControlName="numberOfDentsToShow" />
          </mat-form-field>
        </div>
      </div>
    </form>

    <virtual-scroller class="preview-pattern" #scrollCreelPreview fxFlex [items]="patternsForCreelPreview" horizontal="true">
      <div *ngFor="let patternForCreelPreview of scrollCreelPreview.viewPortItems" fxLayout="column" fxLayoutGap="19px">
        <div class="item-preview" *ngIf="canShowPreviewForYarnSet()">
          <span class="antialiased">{{ getItemViewIndexForYarnType(patternForCreelPreview.yarnType) }}</span>
        </div>

        <div
          *ngIf="canShowPreviewForColorSet()"
          class="item-preview"
          [style.border-color]="patternForCreelPreview.color.hexadecimalColorCode"
          [style.box-shadow]="patternForCreelPreview.color.hexadecimalColorCode"
        >
          <span class="antialiased">{{ getItemViewIndexForColor(patternForCreelPreview.color) }}</span>
        </div>

        <div *ngIf="isCreelPreview()" class="dent-preview" fxFlex>
          <span *ngIf="canShowLabelForDent(patternForCreelPreview.dent)">{{ patternForCreelPreview.dent + 1 }}</span>
        </div>
      </div>
    </virtual-scroller>
  </article>
</section>
